import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { QueueMessage } from "../typeDefs/queueManagement";

export interface QueueManagementState {
	loading: boolean;
	messages: QueueMessage[];
	count: number;
}

const initialState: QueueManagementState = {
	loading: false,
	messages: [],
	count: 0,
};

export const queueManagementSlice = createSlice({
	name: "queueManagement",
	initialState,
	reducers: {
		setMessages: (state, action: PayloadAction<QueueMessage[]>) => {
			state.messages = action.payload;
		},
		setCount: (state, action: PayloadAction<number>) => {
			state.count = action.payload;
		},
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
	},
});

export const { setMessages, setCount, setLoading } =
	queueManagementSlice.actions;

export default queueManagementSlice.reducer;
